import React from "react";
import { Checkbox, Col, Dialog, Divider, FabButton, Flex, Gap, Row, Switchbox, Typography } from "../../ppui";
import { OrganizationBx, OrganizationEmDetails } from "../style";
import { TbPencil } from "react-icons/tb";

function OrgLeavesInfo() {
  
  // State for each modal's visibility
  const [openHolidayInfo, setOpenHolidayInfo] = React.useState(false);

  // Details modal
  const handleOpenHolidayInfoModal = () => setOpenHolidayInfo(true);
  const handleCloseHolidayInfoModal = () => setOpenHolidayInfo(false);
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Weekly Holiday Details
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenHolidayInfoModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Days
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Saturday, Sunday
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Payble
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
      <Divider gap={20} />

      <Flex justifyContent="space-between" gap={"10"}>
        <Typography variant="h5" mb={"0"}>
          Leave Details
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={() => {}}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Leave type
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Calender Year
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Total Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            45
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Casual Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            3
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Medical Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            2
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Privilege Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            5
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Carry Forward
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Earn Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
      <Divider gap={20} />
      <Typography variant="h5" mb={"0"}>
        Carry Forward Details
      </Typography>

      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Casual Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            6
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Medical Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            3
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Privilege Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            8
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>
      <Divider gap={20} />
      <Typography variant="h5" mb={"0"}>
        Earn Leave Details
      </Typography>
      <Gap height={30} />
      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Casual Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            6
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Medical Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            3
          </Typography>
        </OrganizationBx>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Privilege Leave
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            8
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      <Gap height={50} />



            {/* Holiday-info-Modal */}
            <Dialog
        title="Weekly Holiday Information"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={openHolidayInfo}
        onClose={handleCloseHolidayInfoModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
                <Switchbox
          label="Payable Days"
          color="Primary"
          size="lg"
          lableFirst
          mb="20"
        />
        <Gap height={30} />
        <Row rowGap>
        <Col xs={"auto"}>
              <Checkbox color="primary" label={"Sunday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Monday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Tuesday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Wednesday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Thursday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Friday"} />
            </Col>

            <Col xs={"auto"}>
              <Checkbox color="primary" label={"Saturday"} />
            </Col>
        </Row>
      </Dialog>
      {/* Holiday-info-Modal */}
    </>
  );
}

export default OrgLeavesInfo;
